import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const SearchPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SearchPageContainer" */
      './SearchPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
